import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  sales_account: yup.string().required("Sales account is mapping required"),
  sales_return_account: yup
    .string()
    .required("Sales return account mapping is required"),
  discount_given_account: yup
    .string()
    .required("Discount given account mapping is required"),
  cash_bank_payment_method_account: yup
    .string()
    .required("Payment method account mapping is required"),
  sales_delivery_fee_account: yup
    .string()
    .required("Sales delivery fee account mapping is required"),
  customer_credit_account: yup
    .string()
    .required("Customer credit account mapping is required"),
  customer_store_wallet_account: yup
    .string()
    .required("Customer store wallet account mapping is required"),
  customer_loyalty_and_gift_account: yup
    .string()
    .required("Customer loyalty and gift account mapping is required"),
  others_income_account: yup
    .string()
    .required("Others income account mapping is required"),
});

const Validation = ({ salesAccountMapping }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...salesAccountMapping,
    },
  });
};

export default Validation;
